import React from 'react';
import PropTypes from 'prop-types';

class VideoTag extends React.PureComponent {
  static propTypes = {
    videoRef: PropTypes.func,
    onLoadedData: PropTypes.func,
    assets: PropTypes.array.isRequired,
  };

  componentDidMount() {
    const videoNode = this.containerNode.querySelector('video');
    if (this.props.onLoadedData) {
      if (videoNode.readyState !== 4) {
        videoNode.addEventListener('loadeddata', () => this.props.onLoadedData());
      } else {
        this.props.onLoadedData();
      }
    }
    if (this.props.videoRef) {
      this.props.videoRef(videoNode);
    }
  }

  render() {
    const { className, assets } = this.props;
    const playsinline = `playsinline`;
    const muted = `muted`;
    const loop = `loop`;
    const preload = `preload`;
    const videoTagString = `<video ${playsinline} ${muted} ${loop} ${preload}>${assets.map(
      item => `<source src="${item.path}" type="video/${item.type}" />`
    )}</video>`;

    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: videoTagString }}
        ref={node => (this.containerNode = node)}
      />
    );
  }
}

export default VideoTag;



// WEBPACK FOOTER //
// ./src/components/VideoTag.js